import { createAction } from "@reduxjs/toolkit";

export const toggleCadastralDataFormModal = createAction("TOGGLE_CADASTRAL_DATA_FORM_MODAL")